define.alias("shared/components/shared/plan-recommendation/plan-card", "calendar/components/shared/plan-recommendation/plan-card");